<template>
	<div id="Index" class="page page-index" @DOMMouseScroll="forceShow" @mousewheel="forceShow" v-hammer:swipe.up="toLanding" >
		<div class="video-wrapper">
			<cover-container v-if="!Helpers.isMobile()">
				<video ref="video" id="video" class="video" autoplay loop muted preload playsinline webkit-playsinline>
					<source src="/static/video/fifa.webm" type="video/webm">
					<source src="/static/video/fifa.mp4" type="video/mp4">
				</video>
			</cover-container>
			<div class="video-poster" v-else>

			</div>
			<div ref="videoPrev" class="video-preview"
				 style="background-image: url('/static/img/index/video-preview.gif')"></div>
		</div>
		<div ref="overlay" class="page-overlay oh"></div>
		<div class="lines-wrapper">
			<div ref="lines1" class="lines1"></div>
			<div ref="lines2" class="lines2"></div>
			<div v-if="!$store.getters['GET_LOAD_ANIMATE']" ref="circleWrapper" class="lines-circle-wrapper oh">
				<div ref="circle" class="lines-circle"></div>
			</div>
		</div>
		<div ref="logo" class="logo"></div>
		<div v-if="!$store.getters['GET_LOAD_ANIMATE']" ref="criroWrapper" class="criro-wrapper oh">
			<div ref="criro" class="criro"></div>
		</div>
		<div class="page-content">
			<div class="title-wrapper oh">
				<h1 ref="title" class="title">встреча года</h1>
			</div>
			<div class="text-wrapper oh">
				<p ref="text" class="text">
					Любишь компьютерные игры серии FIFA? Мастерски создаешь непобедимые команды? Способен выиграть даже с дублем? Тогда докажи свои умения и окажись в числе тех счастливчиков, которых мы позовем в редакцию на матч в FIFA 18 против реального футболиста РФПЛ.
				</p>
			</div>
			<div ref="arrow" class="scroll-bottom" @click="Helpers.ga().send('click','Стрелка на главной')">
				<router-link to="/rules"><arrow-down></arrow-down></router-link>
			</div>
			<div class="skip" @click="forceShow" v-show="showSkip">
				Пропустить
			</div>
		</div>

		<!--<landing v-if="Helpers.isTouch()"></landing>-->
	</div>

</template>

<script>
	import {TimelineMax} from 'gsap';
	import ArrowDown from '@/assets/svg/arrow_down.svg';
	import Helpers from '@/tools/Helpers';
	import CoverContainer from '@/components/common/CoverContainer';
	import Landing from './landing.vue';

	export default {
		name: 'Index',
		components: {
			ArrowDown,
			Landing,
            CoverContainer
		},
		data() {
			return {
				showSkip: true,
			    Helpers
			}
		},
		methods: {
			skipVideo() {

			},
			innerTLPlay() {
				let self = this;
				return new Promise((resolve) => {

					self.$store.commit('UPD_HANDLE_BLOCK', true);
					TweenMax.fromTo(this.innerTL, this.innerTL.duration(), {time: 0}, {
						time: this.innerTL.duration(), onComplete() {
							self.$store.commit('UPD_HANDLE_BLOCK', false);
							resolve();
						}
					})
				})
			},

			innerTLReverse() {
				let self = this;
				return new Promise((resolve) => {

					self.$store.commit('UPD_HANDLE_BLOCK', true);
					TweenMax.fromTo(this.innerTL, this.innerTL.duration(), {time: this.innerTL.duration()}, {
						time: 0, onComplete() {
							self.$store.commit('UPD_HANDLE_BLOCK', false);
							resolve();
							self.$store.commit('UPD_ANIMATED', true);
						}
					})
				})
			},

			forceShow () {
				this.startTL.progress(1);
				setTimeout( () => {
					this.$store.commit('UPD_ANIMATED', true);
				},500)
				this.showSkip = false;
			},

            toLanding(){
			    if (this.animateEnded) {
                    this.$router.push('/rules');
				}
			}
		},

		beforeRouteLeave: function (to, from, next) {
			this.innerTLPlay().then(() => {
				next();
			});
		},

		mounted() {
			let self = this;
			this.Helpers.ga().send('load', 'Главная страница');
			const logo = this.$refs.logo;
			const title = this.$refs.title;
			const text = this.$refs.text;
			const arrow = this.$refs.arrow;
			const overlay = this.$refs.overlay;
			const lines1 = this.$refs.lines1;
			const lines2 = this.$refs.lines2;
			const criroWrapper = this.$refs.criroWrapper ? this.$refs.criroWrapper : {};
			const circleWrapper = this.$refs.circleWrapper ? this.$refs.circleWrapper : {};

			const video = this.$refs.video;
			const videoPrev = this.$refs.videoPrev;


			this.innerTL = new TimelineMax({
				paused: true
			});

			this.innerTL
				.to(title, .5, {opacity: 0})
				.to(text, .5, {opacity: 0}, '-=.5')
				.to(arrow, .5, {opacity: 0}, '-=.5')
				.to(lines1, .5, {x: '-100%', y: '100%'})
				.to(lines2, .5, {x: '-80%', y: '100%'}, '-=.5')
				.to(overlay, .8, {opacity: 1});
			this.startTL = new TimelineMax({
				paused: true,
				onComplete() {
					self.$store.commit('UPD_LOAD_ANIMATE', true);
				}
			});

			this.startTL
				.to(videoPrev, .5, {opacity: 0})
				.from(logo, 1, {opacity: 0, delay: 5})
				.from(lines1, .5, {x: '-100%', y: '100%'})
				.from(lines2, .5, {x: '-80%', y: '100%'}, '-=.5')
				.from(overlay, .8, {opacity: 0}, Helpers.isTouch() ? 5 : '-=0')
				.to(logo, .5, {opacity: 0})
				.from(circleWrapper, 1, {height: '0em'})
				.from(criroWrapper, 1, {height: '0em'}, '-=1')
				.to(circleWrapper, 1, {height: '0em', delay: 1.5})
				.to(criroWrapper, 1, {height: '0em'}, '-=1')
				.from(title, .5, {
					y: '-100%', onComplete() {
						self.$store.commit('UPD_UI_SHOW', true);
						self.showSkip = false;
					}
				})
				.from(text, .5, {y: '-100%'}, '-=.2')
				.from(arrow, .5, {
					opacity: 0,
					onComplete:()=>{
						arrow.classList.add('animate');
                        this.animateEnded = true;
					}
				});

			if (!this.$store.getters['GET_LOAD_ANIMATE']) {
                if (Helpers.isTouch()) {
                    this.startTL.progress(.4);
                    this.startTL.play();
				}else {
					video.oncanplaythrough = () => {
						this.startTL.play();

					};
				}
			} else {
				this.startTL.progress(1);
				this.innerTLReverse();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Index.vue?2ccf9d1c